import _ from "lodash";

const sortByPrice = (listOfCars = [], sortType = "") => {
  if (sortType === "sort-new") {
    return listOfCars.sort((a, b) => (b.date > a.date ? 1 : -1));
  } else if (sortType === "sort-from") {
    return listOfCars.sort((a, b) => {
      const price_1 = parseFloat(
        _.get(a.acf.prices.rentFromPrice, "rentFromPriceValue", 1000000)
      );
      const price_2 = parseFloat(
        _.get(b.acf.prices.rentFromPrice, "rentFromPriceValue", 1000000)
      );

      const price_1_condition = isNaN(price_1) ? 1000000 : price_1;
      const price_2_condition = isNaN(price_2) ? 1000000 : price_2;

      if (price_1_condition > price_2_condition) {
        return 1;
      } else if (price_1_condition < price_2_condition) {
        return -1;
      } else {
        return 0;
      }
    });
  } else if (sortType === "sort-to") {
    return listOfCars.sort((a, b) => {
      const price_1 = parseFloat(
        _.get(a.acf.prices.rentFromPrice, "rentFromPriceValue", 0)
      );

      const price_2 = parseFloat(
        _.get(b.acf.prices.rentFromPrice, "rentFromPriceValue", 0)
      );

      const price_1_condition = isNaN(price_1) ? 0 : price_1;
      const price_2_condition = isNaN(price_2) ? 0 : price_2;

      if (price_1_condition > price_2_condition) {
        return -1;
      } else if (price_1_condition < price_2_condition) {
        return 1;
      } else {
        return 0;
      }
    });
  } else {
    return listOfCars;
  }
};

const filterPrice = (listOfCars = [], maxPrice = 0) => {
  if (maxPrice === 0 || maxPrice === "0") {
    return listOfCars;
  }

  return listOfCars.filter(car => {
    const carPrice = _.get(
      car,
      "acf.prices.rentFromPrice.rentFromPriceValue",
      0
    );

    return carPrice <= maxPrice;
  });
};

const taxonomyFilter = (listOfCars, taxonomyChecked = [], taxonomyName) => {
  const checkedIds = taxonomyChecked.map(taxo => {
    return taxo.id;
  });

  if (taxonomyChecked.length) {
    return listOfCars.filter(carData => {
      return checkedIds.includes(carData[taxonomyName][0]);
    });
  }

  return listOfCars;
};

export const sortCarsList = (listOfCars = [], filters = {}) => {
  const typpojazdu = taxonomyFilter(
    listOfCars,
    filters.typpojazdu,
    "typpojazdu"
  );
  const typnadwozia = taxonomyFilter(
    typpojazdu,
    filters.typnadwozia,
    "typnadwozia"
  );
  const marki = taxonomyFilter(typnadwozia, filters.marka, "marki");
  const paliwo = taxonomyFilter(marki, filters.rodzajpaliwa, "rodzajpaliwa");
  const skrzynia = taxonomyFilter(paliwo, filters.skrzynia, "skrzynia");
  const maxPrice = filterPrice(skrzynia, _.get(filters, "priceTo[0].slug", 0));
  const byPrice = sortByPrice(maxPrice, _.get(filters, "sort[0].slug", ""));

  if (filters.availableNow) {
    return byPrice.filter(carData => {
      const availableNow = _.get(
        carData,
        "acf.availableNow.availableNowCheckbox",
        false
      );
      return availableNow;
    });
  }

  return byPrice || [];
};
